// Generated by CoffeeScript 2.7.0
var EditActionsModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import SelectUserPopover from 'trunks/vue/admin/components/settings/settings_administrations/select_user_popover.js';

import ActionsSelect from 'trunks/vue/admin/components/settings/settings_administrations/actions_select.js';

export default EditActionsModal = Vue.extend({
  components: {
    'modal': Modal,
    'select-user-popover': SelectUserPopover,
    'actions-select': ActionsSelect
  },
  props: {
    actionList: {
      type: Array
    },
    administration: {
      type: Object
    },
    title: {
      type: String
    },
    resourcesUrl: {
      type: String
    },
    callback: {
      type: Function
    },
    requestMethod: {
      type: String
    }
  },
  data: function() {
    var ref, ref1;
    return {
      selectedUser: (ref = this.administration) != null ? ref.user : void 0,
      selectedActionIds: ((ref1 = this.administration) != null ? ref1.action_ids : void 0) || [],
      userValid: true,
      actionValid: true
    };
  },
  template: `<modal :title="title"
       extendClass="edit-administrator-actions-modal"
       ref="modal">
  <div class="modal-body">
    <div class="field-list-two-item">
      <div class="form-field required" :class="{'has-error': !userValid }">
        <div class="form-field-head">
          <div class="form-field-title">选择用户</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
          <select-user-popover :initialSelectedUser="selectedUser"
                               @valueChanged="userValueChangedFunc" />
          </div>
          <div class="message">请选择用户</div>
        </div>
      </div>
      <div class="form-field required" :class="{'has-error': !actionValid}">
        <div class="form-field-head">
          <div class="form-field-title">选择权限</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input bordered">
            <actions-select :options="options"
                            :initialSelectedItems="selectedItems"
                            @valueChanged="actionValueChangedFunc"/>
          </div>
          <div class="message">请选择权限</div>
        </div>
      </div>
    </div>
  </div>
  
  <template slot="footer">
    <div class="modal-footer">
      <button class="outlined btn-default" @click='cancel'>取消</button>
      <button @click='ensure'>确定</button>
    </div>
  </template>
</modal>`,
  computed: {
    options: function() {
      return _.map(this.actionList, (action) => {
        var ref;
        action._selected = ((ref = this.administration) != null ? ref.action_ids.includes(action.id) : void 0) ? true : false;
        return action;
      });
    },
    selectedItems: function() {
      return _.filter(this.actionList, function(option) {
        return option._selected;
      });
    }
  },
  methods: {
    userValueChangedFunc: function(selectedUser) {
      this.selectedUser = selectedUser;
      return this.userValid = this.selectedUser ? true : false;
    },
    actionValueChangedFunc: function(selectedActions) {
      this.selectedActionIds = this._parseSelectedActionIds(selectedActions);
      return this.actionValid = this.selectedActionIds.length ? true : false;
    },
    getData: function() {
      var ref;
      return {
        administration: {
          action_ids: this.selectedActionIds,
          user_id: (ref = this.selectedUser) != null ? ref.id : void 0
        }
      };
    },
    ensure: function() {
      if (!(this.userValid && this.actionValid)) {
        return;
      }
      return Skylark.Libs.Ajax[this.requestMethod](this.resourcesUrl, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.getData(),
        success: (data) => {
          this.callback(data);
          return this.successFunc();
        },
        error: (xhr, status, error) => {
          return this.errorFunc(error);
        }
      });
    },
    successFunc: function() {
      var text;
      this.cancel();
      text = this.administration ? '编辑成功' : '新增成功';
      return Skylark.Bridge.newAlertify(text, {
        type: 'success'
      });
    },
    errorFunc: function(error) {
      var beforeText, text;
      beforeText = this.administration ? '编辑失败' : '新增失败';
      if (error.user) {
        text = `用户${error.user.join('，')}`;
      }
      if (error.action_ids && text) {
        if (text) {
          text = `${text}，权限${error.action_ids.join('，')}`;
        } else {
          text = `权限${error.action_ids.join('，')}`;
        }
      }
      return Skylark.Bridge.newAlertify(`${beforeText}，${text}`, {
        type: 'error'
      });
    },
    cancel: function() {
      return this.$refs.modal.close();
    },
    _parseSelectedActionIds: function(actions) {
      return _.map(actions, function(item) {
        return item.id.toString();
      });
    }
  }
});
